import * as Yup from 'yup';

export const requiredMessage = 'Поле обязательно для ввода';

Yup.setLocale({ mixed: { required: requiredMessage } });

export const validatePasswordSchema = Yup
  .string()
  .required()
  .min(8, 'Минимальная длина пароля должна составлять 8 символом')
  .matches(
    /(^.*(?=..*[0-9]).*$)/,
    'Пароль должна иметь хотя бы одну цифру',
  )
  .matches(
    /(^.*(?=.*[A-Z]).*$)/,
    'Пароль должна иметь хотя бы одну заглавную букву',
  );

/**
 * Валидация контакта для чека (email или телефон).
 * Начинается с +, 7 или 8 — телефон, иначе — email.
 * Email-regex соответствует PHP filter_var(FILTER_VALIDATE_EMAIL).
 */
export function validateReceiptContact(value: string): string {
  if (!value) return requiredMessage;

  const isPhone = /^[+78]/.test(value);

  if (!isPhone) {
    // Соответствует PHP FILTER_VALIDATE_EMAIL
    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(value)) {
      return 'Введите корректный e-mail';
    }
    return '';
  }

  const digits = value.replace(/\D/g, '');
  if (digits.length >= 2 && !digits.startsWith('7')) {
    return 'Принимаются только российские номера (+7)';
  }
  if (digits.length < 11) {
    return 'Введите корректный номер телефона';
  }
  return '';
}

export function validateInn(inn: string) {
  let result = false;

  if (!inn) return false;

  const checkDigit = function (innValue: string, coefficients) {
    let n = 0;

    coefficients.forEach((k, index) => {
      n += coefficients[index] * Number(innValue[index]);
    });

    return Number(n % 11 % 10);
  };

  switch (inn.length) {
    case 10:
      if (checkDigit(inn, [2, 4, 10, 3, 5, 9, 4, 6, 8]) === Number(inn[9])) {
        result = true;
      }
      break;
    case 12:
      if (
        (checkDigit(inn, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8]) === Number(inn[10]))
        && (checkDigit(inn, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]) === Number(inn[11]))) {
        result = true;
      }
      break;

    default:
      result = false;
  }

  return result;
}
